import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getKeyFromParty } from '../partiesUtils';
import { PartiesSelector } from './PartiesSelector';

type Props = {
  updateParty: (
    data: { name?: string; type?: string } | null | undefined,
  ) => void;
  inputId: string;
  model: { type?: string; name?: string } | null | undefined;
};

type State = {
  inputFocused: boolean;
  name: string;
};

export class PartiesBlock extends React.Component<Props, State> {
  state: State = {
    inputFocused: false,
    name:
      this.props.model && this.props.model.name ? this.props.model.name : '',
  };

  onTypeClick = (type?: 'PP' | 'PM') => () => {
    this.setState({
      name: '',
    });
    const data = type ? { type } : null;
    this.props.updateParty(data);
  };

  onFocus = () => {
    this.setState({
      inputFocused: true,
    });
  };

  onBlur = () => {
    this.setState({
      inputFocused: false,
    });
  };

  submitPartyName = (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    this.props.updateParty({ name: this.state.name });
  };

  onTyping = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = evt.target;
    this.setState({
      name: value,
    });
  };

  render() {
    const { inputId, model } = this.props;
    const { inputFocused, name } = this.state;
    const selectedType = getKeyFromParty(model);

    return (
      <>
        <PartiesSelector
          selected={!selectedType}
          handleClick={this.onTypeClick()}
        >
          <FormattedMessage id="search/components/aside-filters/parties/block/PartiesBlock.tsx/1" />
        </PartiesSelector>
        <PartiesSelector
          selected={selectedType === 'PP'}
          handleClick={this.onTypeClick('PP')}
        >
          <FormattedMessage id="search/components/aside-filters/parties/block/PartiesBlock.tsx/2" />
        </PartiesSelector>
        <PartiesSelector
          selected={selectedType === 'PM'}
          handleClick={this.onTypeClick('PM')}
        >
          <FormattedMessage id="search/components/aside-filters/parties/block/PartiesBlock.tsx/3" />
        </PartiesSelector>
        <PartiesSelector selected={selectedType === 'NAME'}>
          <form
            className="search-filters-parties-name"
            onSubmit={this.submitPartyName}
          >
            <div className="input-group">
              <input
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                onChange={this.onTyping}
                className="input-group-field search-filters-parties-name__field"
                placeholder="Partie spécifique (ex : CIC, Urssaf...)"
                id={inputId}
                type="text"
                value={name}
                autoComplete="off"
                spellCheck={false}
              />
              {(!!name || inputFocused) && (
                <div className="input-group-button">
                  <input
                    type="submit"
                    disabled={!name}
                    className="button"
                    value="Valider"
                  />
                </div>
              )}
            </div>
          </form>
        </PartiesSelector>
      </>
    );
  }
}
